/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * `afterDays` counts from the previous enabled stage (reminder → warning → autoClose),
 * or from the day the check was first seen non-green when no earlier stage is enabled.
 * `comment` supports {author}, {check} and {days} (autoClose.afterDays).
 * @export
 * @interface CheckStageConfig
 */
export interface CheckStageConfig {
    /**
     * 
     * @type {boolean}
     * @memberof CheckStageConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof CheckStageConfig
     */
    afterDays?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckStageConfig
     */
    comment?: string;
}

export function CheckStageConfigFromJSON(json: any): CheckStageConfig {
    return CheckStageConfigFromJSONTyped(json, false);
}

export function CheckStageConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckStageConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'afterDays': !exists(json, 'afterDays') ? undefined : json['afterDays'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function CheckStageConfigToJSON(value?: CheckStageConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'afterDays': value.afterDays,
        'comment': value.comment,
    };
}

